'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { BATTLESHIP, GYPSUM } from 'HubStyleTokens/colors';
import FormattedCurrency from 'I18n/components/FormattedCurrency';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
import UIBadge from 'UIComponents/badge/UIBadge';
import UICardHero from 'UIComponents/card/UICardHero';
import UICardSection from 'UIComponents/card/UICardSection';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import AbstractTextElement from 'UIComponents/elements/AbstractTextElement';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIImage from 'UIComponents/image/UIImage';
import UIFlex from 'UIComponents/layout/UIFlex';
import { STAR_RATING_FILLED } from '../../constants/reviews/RatingTypes';
import { MINIMUM_REVIEWS_FOR_DISPLAY } from '../../constants/reviews/ReviewsListQueries';
import { formatCentsToDollars } from '../../utils/currency';
import Rating from '../reviews/Rating';
const THUMBNAIL_PLACEHOLDER_FLEX_CONTAINER_CLASS = 'theme-card__thumbnail-placeholder__flex';
const ThumbnailPlaceholder = styled(props => /*#__PURE__*/_jsx("div", Object.assign({}, props, {
  children: /*#__PURE__*/_jsx(UIFlex, {
    className: THUMBNAIL_PLACEHOLDER_FLEX_CONTAINER_CLASS,
    align: "center",
    justify: "center",
    children: /*#__PURE__*/_jsx(UIIcon, {
      color: BATTLESHIP,
      name: "insertImage",
      size: 120
    })
  })
}))).withConfig({
  displayName: "ThemeCard__ThumbnailPlaceholder",
  componentId: "sc-36rtkv-0"
})(["position:relative;width:100%;padding-top:75%;background-color:", ";border-top-left-radius:inherit;border-top-right-radius:inherit;overflow:hidden;.", "{position:absolute;top:0;left:0;bottom:0;right:0;}"], GYPSUM, THUMBNAIL_PLACEHOLDER_FLEX_CONTAINER_CLASS);
ThumbnailPlaceholder.displayName = 'ThumbnailPlaceholder';
const StyledPrice = styled(AbstractTextElement).withConfig({
  displayName: "ThemeCard__StyledPrice",
  componentId: "sc-36rtkv-1"
})(["font-size:20px;"]);
StyledPrice.displayName = 'StyledPrice';

const ThemeCard = ({
  className,
  name,
  priceCents,
  companyName,
  reviewSummary,
  thumbnailUrl
}) => {
  return /*#__PURE__*/_jsxs(UICardWrapper, {
    className: className,
    compact: true,
    children: [thumbnailUrl ? /*#__PURE__*/_jsx(UICardHero, {
      children: /*#__PURE__*/_jsx(UIImage, {
        width: "100%",
        alt: companyName,
        src: thumbnailUrl
      })
    }) : /*#__PURE__*/_jsx(ThumbnailPlaceholder, {}), /*#__PURE__*/_jsxs(UICardSection, {
      scrollable: true,
      children: [/*#__PURE__*/_jsx("div", {
        className: "is--heading-4 m-bottom-0",
        children: name
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ecosystemMarketplaceCore.cards.themeCard.companyName",
            options: {
              companyName: companyName || ''
            }
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "m-y-2",
        children: /*#__PURE__*/_jsx(UIBadge, {
          use: "koala",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ecosystemMarketplaceCore.cards.themeCard.offeringType"
          })
        })
      })]
    }), /*#__PURE__*/_jsx(UICardSection, {
      className: "p-top-0",
      children: /*#__PURE__*/_jsxs(UIFlex, {
        align: "baseline",
        justify: "between",
        children: [reviewSummary && reviewSummary.reviewCount >= MINIMUM_REVIEWS_FOR_DISPLAY ? /*#__PURE__*/_jsx(Rating, {
          rating: reviewSummary.overallRating,
          label: reviewSummary.reviewCount,
          use: "card",
          type: STAR_RATING_FILLED
        }) : /*#__PURE__*/_jsx("span", {}), priceCents != null ? /*#__PURE__*/_jsx(StyledPrice, {
          weight: "medium",
          children: priceCents === 0 ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ecosystemMarketplaceCore.cards.themeCard.planType.free"
          }) : /*#__PURE__*/_jsx(FormattedCurrency, {
            currencyCode: "USD",
            simplifyCurrency: true,
            value: formatCentsToDollars(priceCents)
          })
        }) : null]
      })
    })]
  });
};

ThemeCard.propTypes = {
  className: PropTypes.string,
  companyName: PropTypes.string,
  name: PropTypes.string,
  priceCents: PropTypes.number,
  reviewSummary: PropTypes.shape({
    overallRating: PropTypes.number.isRequired,
    reviewCount: PropTypes.number.isRequired
  }),
  thumbnailUrl: PropTypes.string
};
export default ThemeCard;